// extracted by mini-css-extract-plugin
module.exports = {"playerBody":"player_playerBody_2JH3OUN","screenWrapper":"player_screenWrapper_3yfit-n","disconnected":"player_disconnected_300pLqr","playerView":"player_playerView_1tJJ_XD"};